
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth } from '../../constants/api';
import {
	PROVINCE_FETCH,
	SUB_PROVINCE_FETCH,
	DISTRICT_FETCH,

} from '../actions';

import {
	provinceSuccess,
	provinceFail,
	subprovinceSuccess,
	subprovinceFail,
	districtSuccess,
	districtFail,

} from './actions';

import { sortOrder } from '../../helpers/Utils';

const provinceFetchAsync = async () =>
	await API.post('/setting/province', {

	},
		{
			"headers": auth
		})
		.then(payments => payments)
		.catch(error => error);

function* provinceFetch({ payload }) {

	try {
		const provinceFetch = yield call(provinceFetchAsync);

		if (provinceFetch.data.StatusCode === "0000") {
			const data = provinceFetch.data.ResultValues
			// console.log('dataprovince -> ', data)
			yield put(provinceSuccess(data));
		} else {
			yield put(provinceFail(provinceFetch.data.Message));
		}
	} catch (error) {
		yield put(provinceFail(error));
	}
}


const subprovinceFetchAsync = async (req) =>
	await API.post('/setting/getsubprovincelist', {
		ProvinceId: req.ProvinceId,
	},
		{
			"headers": auth
		})
		.then(payments => payments)
		.catch(error => error);

function* subprovinceFetch({ payload }) {

	const { subprovince } = payload;

	try {
		const subprovinceFetch = yield call(subprovinceFetchAsync, subprovince);

		if (subprovinceFetch.data.StatusCode === "0000") {
			const data = subprovinceFetch.data.ResultValues.sort(sortOrder('province_name'))
			yield put(subprovinceSuccess(data));
		} else {
			yield put(subprovinceFail(subprovinceFetch.data.Message));
		}
	} catch (error) {
		yield put(subprovinceFail(error));
	}
}

const districtFetchAsync = async (req) =>
	await API.post('/setting/getdistrictlist', {
		ProvinceId: req.ProvinceId,
		SubProvinceId: req.SubProvinceId
	},
		{
			"headers": auth
		})
		.then(payments => payments)
		.catch(error => error);

function* districtFetch({ payload }) {
	const { district } = payload;

	try {
		const districtFetch = yield call(districtFetchAsync, district);

		if (districtFetch.data.StatusCode === "0000") {
			const data = districtFetch.data.ResultValues.sort(sortOrder('province_name'))
			yield put(districtSuccess(data));
		} else {
			yield put(districtFail(districtFetch.data.Message));
		}
	} catch (error) {
		yield put(districtFail(error));
	}
}



export function* watchMerchantFetch() {
	yield takeEvery(PROVINCE_FETCH, provinceFetch);
	yield takeEvery(SUB_PROVINCE_FETCH, subprovinceFetch);
	yield takeEvery(DISTRICT_FETCH, districtFetch);
}

export default function* rootSaga() {
	yield all([
		fork(watchMerchantFetch),
	]);
}
